import { SvgProps } from 'models/svg';

const EmailAtSignSvg = ({ className }: SvgProps) => {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M6 2C3.51562 2 1.5 4.01562 1.5 6.5C1.5 8.98438 3.51562 11 6 11C6.42188 11 6.75 11.3281 6.75 11.75C6.75 12.1719 6.42188 12.5 6 12.5C2.69531 12.5 0 9.80469 0 6.5C0 3.19531 2.69531 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5V7.25C12 8.49219 10.9922 9.5 9.75 9.5C9.07031 9.5 8.4375 9.19531 8.03906 8.70312C7.5 9.19531 6.79688 9.5 6 9.5C4.33594 9.5 3 8.16406 3 6.5C3 4.83594 4.33594 3.5 6 3.5C6.65625 3.5 7.26562 3.71094 7.75781 4.0625C7.875 3.94531 8.0625 3.875 8.25 3.875C8.67188 3.875 9 4.20312 9 4.625V7.25C9 7.67188 9.32812 8 9.75 8C10.1719 8 10.5 7.67188 10.5 7.25V6.5C10.5 4.01562 8.48438 2 6 2ZM7.5 6.5C7.5 5.67969 6.82031 5 6 5C5.17969 5 4.5 5.67969 4.5 6.5C4.5 7.32031 5.17969 8 6 8C6.82031 8 7.5 7.32031 7.5 6.5Z'
        fill='#6C727F'
      />
    </svg>
  );
};

export default EmailAtSignSvg;
